import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const CREATE_PREBID_MODULE: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation createPrebidModule($input: CreateWorkspacePrebidModuleInput!) {
    createWorkspacePrebidModule(input: $input) {
      workspacePrebidModule {
        id
        prebidModule {
          demand
        }
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`
